module.exports = __webpack_public_path__ + "img/R.c84bb621.png";